export interface Critere {
  id?: string;
  uuid?: string;
  author: string;
  name: string;
  type: TypeEnum;
  format?: FormatEnum;
  unite?: string;
  min?: number;
  max?: number;
  alertMin?: number;
  alertMax?: number;
  cotation?: number;
  description?: string;
  isUploaded?: boolean;
  isDownloaded?: boolean;
  disabled?: boolean;
}

export enum TypeEnum {
  Numerique = "numerique",
  Alphanumerique = "alphanumerique",
}

export enum FormatEnum {
  FormatDizaine = "format_dizaine",
  FormatUnite = "format_unite",
  FormatDixieme = "format_dixieme",
  FormatCentieme = "format_centieme",
  FormatMillieme = "format_millieme",
}
